var _circle, _path, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44",
    width: 44,
    height: 44,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "quickMapGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#F5F0E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#5F7A61"
    }
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 20,
    fill: "url(#quickMapGradient)",
    opacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 22 12 Q 26 12 26 18 Q 26 22 22 30 Q 18 22 18 18 Q 18 12 22 12 Z",
    fill: "url(#quickMapGradient)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 18,
    r: 3,
    fill: "#FFFFFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 14,
    r: 3,
    fill: "#5F7A61"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 20,
    fill: "none",
    stroke: "#F5F0E6",
    strokeWidth: 1,
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickMap);
export default __webpack_public_path__ + "static/media/quick-map.a878132d9660d4805ce0797830540d91.svg";
export { ForwardRef as ReactComponent };